import { useTemplatesForLocation } from '@/services/shared/useTemplatesForLocation';
import { WorkingRoster } from '@/types/roster.types';
import { useCallback } from 'react';
import { useWorkingRosterToGqlTemplate } from '../rosterHelper';

export const useGetUpdateTemplateFromWorkingRoster = () => {
  const { templateOptions } = useTemplatesForLocation();
  const workingRosterToGqlTemplate = useWorkingRosterToGqlTemplate();

  return useCallback(
    (workingRoster: WorkingRoster) => {
      const rosterOrigin = templateOptions.find(t => t.id === workingRoster?.templateId)?.template;

      return workingRosterToGqlTemplate(workingRoster, rosterOrigin, true);
    },
    [templateOptions, workingRosterToGqlTemplate]
  );
};
